import styles from "./TeamSection.module.scss";
import { RefObject } from "react";
import { ESectionOptions } from "@/frontend/widgets/Sidebar";
import { TeamSectionByAi, TTeamSectionByAiProps } from "./TeamSectionByAi/TeamSectionByAi";
import { TeamSectionByInnovera, TTeamSectionByInnoveraProps } from "./TeamSectionByInnovera/TeamSectionByInnovera";
import { SquareButton } from "@/frontend/shared/ui/Button";
import { EditIcon } from "@/frontend/shared/assets/icons";
import { SectionTitle } from "../Section/SectionTitle/SectionTitle";

type TTeamSectionProps = {
  innerRef: RefObject<HTMLDivElement>;
  className?: string;
} & TTeamSectionByAiProps &
  TTeamSectionByInnoveraProps;

export function TeamSection({ innerRef, className, onEdit, ...props }: TTeamSectionProps) {
  return (
    <div className={className}>
      <div className={styles.container}>
        <div className={styles.refContainer} data-section={ESectionOptions.TEAM} ref={innerRef}>
          <div className={styles.contentContainer}>
            <div className={styles.titleContainer}>
              <SectionTitle>Team</SectionTitle>

              {!!onEdit && (
                <SquareButton size="large" variant="tertiary" onClick={onEdit} title="Edit">
                  <EditIcon />
                </SquareButton>
              )}
            </div>
            <TeamSectionByAi {...props} onEdit={onEdit} />
            <TeamSectionByInnovera {...props} />
          </div>
        </div>
      </div>
    </div>
  );
}
